import { AppBar, Grid, Toolbar, Typography } from "@mui/material";
import { useContext } from "react";
import BasicMenu from "../elements/BasicMenu";
import { LoginUserContext } from "../provider/LoginUserProvider";

const drawerWidth = 240;

const Header = ({ setMobileOpen, mobileOpen, isClosing }) => {
  const { loginUser } = useContext(LoginUserContext);
  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <Grid container sx={{ width: "100%" }}>
            <Grid size={6}>
              <BasicMenu
                setMobileOpen={setMobileOpen}
                mobileOpen={mobileOpen}
                isClosing={isClosing}
              />
            </Grid>
            <Grid size={6} sx={{ py: 1 }}>
              {/* {props.name} */}
              <Typography variant="p" component="div" sx={{ flexGrow: 1 }}>
                ログインユーザー：{loginUser}
              </Typography>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
